// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const feedTrough = defineModel({
  id: "feed-trough",
  batchId: "future",
  name: "Feed trough",
  tags: ["scenery","feed","trough","low-poly","age-of-mcp","future"],
  summary: "A trough of fodder feeding penned or working animals.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.4,
  parts: () => [
      { geometry: new THREE.BoxGeometry(0.7, 0.18, 0.04), color: "#8a6840", position: [0, 0.2, -0.11], rotation: [0.5, 0, 0] },
      { geometry: new THREE.BoxGeometry(0.7, 0.18, 0.04), color: "#8a6840", position: [0, 0.2, 0.11], rotation: [-0.5, 0, 0] },
      { geometry: new THREE.BoxGeometry(0.05, 0.16, 0.28), color: "#6e4f2e", position: [-0.34, 0.2, 0] },
      { geometry: new THREE.BoxGeometry(0.05, 0.16, 0.28), color: "#6e4f2e", position: [0.34, 0.2, 0] },
      { geometry: new THREE.BoxGeometry(0.05, 0.14, 0.05), color: "#563d22", position: [-0.3, 0.06, -0.06] },
      { geometry: new THREE.BoxGeometry(0.05, 0.14, 0.05), color: "#563d22", position: [0.3, 0.06, -0.06] },
      { geometry: new THREE.BoxGeometry(0.05, 0.14, 0.05), color: "#563d22", position: [-0.3, 0.06, 0.06] },
      { geometry: new THREE.BoxGeometry(0.05, 0.14, 0.05), color: "#563d22", position: [0.3, 0.06, 0.06] },
      { geometry: new THREE.ConeGeometry(0.1, 0.18, 7), color: "#cdb24a", position: [-0.18, 0.3, 0.02] },
      { geometry: new THREE.ConeGeometry(0.09, 0.16, 7), color: "#bda03e", position: [0.12, 0.29, -0.04], rotation: [0.3, 0, 0.2] },
      { geometry: new THREE.ConeGeometry(0.07, 0.13, 7), color: "#cdb24a", position: [0.28, 0.28, 0.06], rotation: [-0.2, 0, -0.3] },
    ],
  animations: [],
});
